<template>
  <portal
    to="modal"
    :disabled="!shouldShow"
    :style="{ position: 'absolute' }"
  >

    <ar-modal
      :is-open="shouldShow"
      :header="!!integration ? 'Connect to ' + integration.name : 'Connect'"
      :has-cross-icon="!isWaiting"
      class="tixr-modal"
      width="590px"
      :mobile="$arMediaQuery.window.maxWidth('xs')"
      @close="handleCloseClick"
    >

      <div
        slot="body"
        :class="[
          'tixr-modal-body',
          $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
        ]"
      >
        <ar-field
          label="Public Key"
        >
          <ar-input
            v-bind:class="{'error-border': errorMessage}"
            v-model="clientPartnerKey"
            name="clientPartnerKey"
            placeholder="Please enter your Tixr public key"
            :disabled="isWaiting"
          />
        </ar-field>

        <ar-field
          label="Secret Key"
          :style="{
            marginTop: '20px',
          }"
        >
          <ar-input
            v-bind:class="{'error-border': errorMessage}"
            v-model="privateKey"
            name="privateKey"
            type="password"
            placeholder="Please enter your Tixr secret key"
            :disabled="isWaiting"
          />
        </ar-field>

        <ar-field
          label="Account Name"
          :style="{
            marginTop: '20px',
          }"
        >
          <ar-input
            v-bind:class="{'error-border': errorMessage}"
            v-model="accountName"
            name="accountName"
            placeholder="Please enter your Tixr account name"
            :disabled="isWaiting"
          />
        </ar-field>
      </div>

      <div
        slot="footer"
        :class="[
          isWaiting ? 'tixr-waiting-modal-footer' : 'tixr-modal-footer',
          $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
        ]">
        <div v-if="errorMessage" :class="'error-container'">
          <span v-bind:class="{'error-message': errorMessage}">
            {{ '* ' + errorMessage }}
          </span>
          <div
            :class="'connection-guide'">
            <a
              target="_blank"
              href="https://intercom.help/audiencerepublic/en/articles/11175135-how-to-connect-to-tixr">
              View our connection guide
            </a>
            <ar-icon
              name="external-link"
              width="24px"
              height="24px"
              style="vertical-align: text-bottom; padding-left: 5px;"
            />
          </div>
          
        </div>

        <am2-loading-bubble v-if="isWaiting"/>
        <ar-simple-button
          v-else
          text="Confirm"
          :loading="isWaiting"
          :disabled="confirmButtonDisabled"
          :style="confirmButtonStyle"
          @click="handleConfirmClick"
        />
      </div>

    </ar-modal>

  </portal>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'TixrModal',
  components: {},
  props: {
    shouldShow: {
      type: Boolean,
      default: false,
    },
    isWaiting: {
      type: Boolean,
      default: false,
    },
    integration: {
      type: Object,
      default: null
    },
    providerAccount: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      clientPartnerKey: null,
      privateKey: null,
      accountName: null,
      errorMessage: null,
      httpStatus: null
    };
  },

  computed: {
    confirmButtonDisabled() {
      return !this.clientPartnerKey || !this.privateKey || !this.accountName;
    },
    confirmButtonStyle() {
      return {
        width: '108px',
        position: 'absolute',
        right: '30px'
      };
    }
  },

  watch: {
    async shouldShow(val) {
      if (val) {
        this.clientPartnerKey = null;
        this.privateKey = null;
        this.accountName = null;
        this.errorMessage = null;
        this.httpStatus = null;
      }
    },
  },

  methods: {
    ...mapActions([
      'workatoIntegration/CREATE_PROVIDER_ACCOUNT'
    ]),

    async handleConfirmClick() {
      this.errorMessage = null;
      this.httpStatus = null;
      const response = await this['workatoIntegration/CREATE_PROVIDER_ACCOUNT']({
        integration: this.integration,
        account: {
          accountName: this.accountName || 'Default Account',
          integration: {
            account: {
              clientPartnerKey: this.clientPartnerKey,
              privateKey: this.privateKey
            }
          }
        }
      });
      if (response.success) {
        this.$emit('complete');
      }
      else {
        this.errorMessage = response.message;
        this.httpStatus = response.httpStatusCode;
      }
    },

    handleCloseClick() {
      this.$emit('cancel');
    },
  }
};
</script>

<style lang="scss" scoped>
.tixr-modal {
  .tixr-modal-body {
    padding: 20px 30px 30px;
  }

  .tixr-modal-footer {
    display: flex;
    align-items: center;
    padding: 25px 30px;
    height: 100px;
  }
}

.tixr-waiting-modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 30px;
  height: 100px;
}

.error-container {
  display: flex;
  flex-direction: column;
  width: calc(100% - 180px);
}

.connection-guide {
  padding-top: 5px;
  text-decoration: underline;
  width: fit-content;
  color: #7344c0;
  cursor: pointer;
}

.error-border {
  border: 1px solid red;
  box-shadow: 0 0 0 3px #f7a1a7;
}

.error-message {
  color: red;
  font-weight: 12px;
}

</style>
